import { EgretLoadable } from "egret";

const TicketDepartmentsTrends = EgretLoadable({
  loader: () => import("./TicketDepartmentsTrends/TicketDepartmentsTrends")
});

const TicketResolutionTime = EgretLoadable({
  loader: () => import("./TicketResolutionTime/TicketResolutionTime")
});

const TicketCustomerEmotions = EgretLoadable({
  loader: () => import("./TicketCustomerEmotions/TicketCustomerEmotions")
});

const TicketFeedbackEmotions = EgretLoadable({
  loader: () => import("./TicketFeedbackEmotions/TicketFeedbackEmotions")
});

const TicketCustomerEmotionsHeatmap = EgretLoadable({
  loader: () => import("./TicketCustomerEmotionsHeatmap/TicketCustomerEmotions")
});

const AgentsPerformance = EgretLoadable({
  loader: () => import("./AgentsPerformance/AgentsPerformance")
});
 
 
const reportsRoute = [
  {
      path: "/TicketDepartmentsTrendsReport",
      exact: true,
      component: TicketDepartmentsTrends
  }, 
  {
    path: "/TicketResolutionTimeReport",
    exact: true,
    component: TicketResolutionTime
  }, 
  {
    path: "/TicketCustomerEmotions",
    exact: true,
    component: TicketCustomerEmotions
  }, 
  {
    path: "/TicketFeedbackEmotions",
    exact: true,
    component: TicketFeedbackEmotions
  },
  {
    path: "/TicketCustomerEmotionsHeatmap",
    exact: true,
    component: TicketCustomerEmotionsHeatmap
  },
  {
    path: "/AgentsPerformance",
    exact: true,
    component: AgentsPerformance
  }
];

export default reportsRoute;
